module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_3009.6bcc6dcf.png";